"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _RecentActivityHeaderWithFilterComponent = _interopRequireDefault(require("./RecentActivityHeaderWithFilterComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _RecentActivityHeaderWithFilterComponent["default"];